import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";

/**
 * @class ScheduledMaintenance
 *
 */
export class ScheduledMaintenance extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {

        return [ 'title', 'content' ];
    }

    static get validationModel() {

        return {
            title: {
                label: 'ENGLISH_TITLE'
            },
            title_ar: {
                label: 'ARABIC_TITLE'
            },
            content: {
                label: 'ENGLISH_CONTENT'
            },
            content_ar: {
                label: 'ARABIC_CONTENT'
            },
        };
    }
}

AccessorsMutatorsDecorator('id', ...ScheduledMaintenance.translatableAttributesWithLanguageAliases, 'from', 'to', 'status', 'user', 'users', 'users_count', 'created_at', 'updated_at')(ScheduledMaintenance);


// WEBPACK FOOTER //
// ./src/pms-api/models/scheduled-maintenance.model.js